import React from 'react';
import PropTypes from 'prop-types';
import HeadshotComponent from './headshot';
import ConversationDetailsComponent from './conversation_details';

class MainNav extends React.Component {
  constructor(props) {
    super(props);
  }

  componentWillReceiveProps(newProps) {
    if (!newProps.conversationDetailsVisible) {
      this.setDisplayDetails(false);
    }
  }

  roomName() {
    if (this.props.conversation.attachedToEvent) {
      return (
        <a href={this.props.conversation.eventLink}>{this.props.conversation.name}</a>
      );
    }
  }

  roomHeadshot() {
    let headshotObj;

    if (this.props.conversation.attachedToEvent) {
      const conversation = this.props.conversation;
      headshotObj = {
        id: conversation.id,
        headShotImage: conversation.eventImage,
        displayName: conversation.name
      };
    } else {
      headshotObj = this.props.users;
    }

    return <HeadshotComponent user={headshotObj} />;
  }

  fullNameList(users) {
    return users.map(user => user.displayName).join(', ');
  }

  truncatedNameList(users) {
    if (!users[0]) { return null; }
    var name = users[0].displayName;
    if (users.length > 1) { name += ` + ${users.length - 1}`; }
    return name;
  }

  handleAllConversationsClick() {
    this.props.closeConversationDetails();
    this.props.allConversations();
  }

  setDisplayDetails(display) {
    if (display) {
      this.props.openConversationDetails();
    } else {
      this.props.closeConversationDetails();
    }
  }

  newConversationRender() {
    return (
      <section className="col-md-9 col-md-offset-3 main-nav">
        <div className="main-nav-contents">
          <div className="t2 all-conversations visible-xs visible-sm pt-15"
            onClick={this.props.closeConversationCreator.bind(this, { transitionRoute: true })}>
            <i className="fa fa-chevron-left fa-lg"></i>
          </div>
          <p className="t3 w3 participant-name-list">New conversation</p>
        </div>
      </section>
    );
  }

  render() {
    if (this.props.newConversation) { return this.newConversationRender(); }
    if (!this.props.hasActiveConversation || !this.props.users.length) { return null; }
    const columnClass = this.props.conversationDetailsVisible ? 'col-md-6' : 'col-md-9';

    return (
      <section className={`${columnClass} col-md-offset-3 main-nav`}>
        <div className="main-nav-contents">
          <div className="t2 all-conversations visible-xs visible-sm mr-10 pt-15" onClick={this.handleAllConversationsClick.bind(this)}>
            <i className="fa fa-chevron-left fa-lg"></i>
          </div>

          <span>
            {this.roomHeadshot()}
          </span>

          <div className="participant-name-list flex-grow-1">
            <p className="t3 w3 hidden-xs">
              {this.roomName() || this.fullNameList(this.props.users)}
            </p>
            <p className="t3 w3 hidden-sm hidden-md hidden-lg">
              {this.roomName() || this.truncatedNameList(this.props.users)}
            </p>
          </div>

          <div className="t2 participant-list-actions">
            <div className={`toggle-details menu-toggle btn-sq ${this.props.conversationDetailsVisible ? 'open' : 'closed'}`}
              onClick={this.setDisplayDetails.bind(this, !this.props.conversationDetailsVisible)}>
              <i className="fa fa-ellipsis-h"></i>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

MainNav.propTypes = {
  hasActiveConversation: PropTypes.bool.isRequired,
  users: PropTypes.array.isRequired,
  newConversation: PropTypes.bool.isRequired,
  allConversations: PropTypes.func.isRequired,
  conversation: PropTypes.object.isRequired,
  closeConversationCreator: PropTypes.func.isRequired
};

export default MainNav;
